import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import isNil from 'lodash.isnil';
import getNotCompletedCompehension from '../../../../utils/shared/probeDetailsUtils';
import { ID } from '../../../../constants/shared/TrcConstants';
import Comprehension from './comprehension/Comprehension';
import ReadingRecord from './readingRecord/ReadingRecord';

const { COMPREHENSION } = ID;

const TroPageContent = ({
    selectedTabId,
    booksData,
    bookResult,
    bookInformation,
    listOfSentences,
    readingStats,
    leftDaysNotification,
    student,
    patchBookContentRemarks,
    showRevertModal,
    showUntranscribableModal,
    revertToSoapBoxResult,
    confirmationModalType,
    closeConfirmationPopup,
    audioLookerEvent,
    troBookRescoringEvent,
}) => {
    if (selectedTabId === COMPREHENSION) {
        const comprehension = get(bookResult, 'comprehensionResult.score', '');
        const { questions } = booksData;
        const { lastName, firstName } = student;

        return !isNil(comprehension) ? (
            <Comprehension questions={questions} bookResult={bookResult} />
        ) : (
            getNotCompletedCompehension(firstName, lastName)
        );
    }
    return (
        <ReadingRecord
            bookResult={bookResult}
            listOfSentences={listOfSentences}
            readingStats={readingStats}
            bookInformation={bookInformation}
            leftDaysNotification={leftDaysNotification}
            patchBookContentRemarks={patchBookContentRemarks}
            showRevertModal={showRevertModal}
            showUntranscribableModal={showUntranscribableModal}
            revertToSoapBoxResult={revertToSoapBoxResult}
            confirmationModalType={confirmationModalType}
            closeConfirmationPopup={closeConfirmationPopup}
            audioLookerEvent={audioLookerEvent}
            troBookRescoringEvent={troBookRescoringEvent}
        />
    );
};
TroPageContent.defaultProps = {
    leftDaysNotification: '',
    bookInformation: {},
    booksData: {},
    bookResult: {},
    readingStats: {},
    selectedTabId: null,
    student: {},
    listOfSentences: [],
    confirmationModalType: null,
    showRevertModal: () => {},
    showUntranscribableModal: () => {},
    closeConfirmationPopup: () => {},
    patchBookContentRemarks: () => {},
    revertToSoapBoxResult: () => {},
    audioLookerEvent: () => {},
    troBookRescoringEvent: () => {},
};

TroPageContent.propTypes = {
    leftDaysNotification: PropTypes.string,
    bookInformation: PropTypes.object,
    bookResult: PropTypes.object,
    booksData: PropTypes.object,
    readingStats: PropTypes.object,
    listOfSentences: PropTypes.array,
    selectedTabId: PropTypes.string,
    student: PropTypes.object,
    confirmationModalType: PropTypes.string,
    closeConfirmationPopup: PropTypes.func,
    patchBookContentRemarks: PropTypes.func,
    revertToSoapBoxResult: PropTypes.func,
    showRevertModal: PropTypes.func,
    showUntranscribableModal: PropTypes.func,
    audioLookerEvent: PropTypes.func,
    troBookRescoringEvent: PropTypes.func,
};
export default TroPageContent;
